<template>
  <div class="card">
    <div class="card-header">
      <div class="utils__title">
        <strong>Obrázky - Upravit <span class="utils__link--underlined text-primary">#{{ id }}</span></strong>
      </div>
      <action-tools :router-options="routerOptions"></action-tools>
    </div>
    <div class="card-body">
      <a-form :form="form" @submit="handleSubmit">
        <a-form-item label="Obrázek">
          <div :class="$style.gallery">
            <div :class="$style.item">
              <img v-if="!isImageError && detail && detail.iae_path" class="img-fluid" v-lazy="$uploadImagePath + detail.iae_path + (detail.is_breadcrumb ? '_bc.' : '_6.') + detail.iae_format" @error="isImageError = true">
              <a-icon v-else theme="twoTone" twoToneColor="#ccc" type="frown" />
            </div>
          </div>
        </a-form-item>

        <a-form-item label="Formát">
          <p>{{ detail.iae_format }}</p>
        </a-form-item>

        <a-form-item label="Je breadcrumb?">
          <p>{{ detail.is_breadcrumb ? 'Ano' : 'Ne' }}</p>
        </a-form-item>

        <a-form-item label="Zaměření ořezu">
          <focal-point-picker
            v-if="!isImageError && detail && detail.iae_path"
            :image-src="$uploadImagePath + detail.iae_path + (detail.is_breadcrumb ? '_bc.' : '_6.') + detail.iae_format"
            v-model="focal"
          ></focal-point-picker>
        </a-form-item>

        <a-form-item
          label="Název"
          :validate-status="error('iae_name') ? 'error' : ''"
          :help="error('iae_name') || ''"
        >
          <a-input
            v-decorator="[`iae_name`, {rules: [{max: 100, message: 'Název nemůže být delší než 100 znaků!'}, {required: true, message: 'Název musí být vyplněna!'}]}]"
            placeholder="Název"
          />
        </a-form-item>

        <a-form-item
          label="Kategorie"
          :validate-status="error('icy_id') ? 'error' : ''"
          :help="error('icy_id') || ''"
        >
          <a-select
            v-decorator="[`icy_id`, {rules: [{required: true, message: 'Kategorie musí být vyplněna!'}]}]"
            showSearch
            placeholder="-- Vyber kategorii --"
            :options="categories.map(x => { return { value: x.icy_id, label: x.icy_name }})"
            optionFilterProp="children"
            :filterOption="filterOption"
            :loading="!loaded.includes('icy')"
          />
        </a-form-item>
        <div class="form-actions">
          <a-button html-type="submit" type="primary" :disabled="loading || hasErrors(form.getFieldsError())">Upravit</a-button>
        </div>
      </a-form>
    </div>
  </div>
</template>

<script>
import ActionTools from '@/components/MyComponents/ActionTools'
import FocalPointPicker from '@/components/MyComponents/FocalPointPicker'
import { hasErrors } from '../../../services/forms'

export default {
  components: { ActionTools, FocalPointPicker },
  data: function () {
    return {
      hasErrors,
      loading: false,
      routerOptions: [
        {
          icon: 'bars',
          theme: 'outlined',
          to: '/image',
          title: 'Seznam',
        },
      ],
      form: this.$form.createForm(this),
      id: this.$route.params.id,
      loaded: [],
      isImageError: false,
      focal: { x: 50, y: 50 },
    }
  },
  computed: {
    detail: function () {
      return this.$store.getters['image/getDetail']
    },
    categories: function () {
      return this.$store.getters['imageCategory/filteredItems']('')
    },
  },
  methods: {
    getData() {
      return {
        icy_id: this.form.getFieldValue('icy_id'),
        iae_name: this.form.getFieldValue('iae_name'),
        iae_focal_x: this.focal.x,
        iae_focal_y: this.focal.y,
      }
    },
    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLocaleLowerCase().indexOf(input.toLocaleLowerCase()) >= 0
    },
    handleSubmit(e) {
      e.preventDefault()
      this.form.validateFields((err, values) => {
        if (!err) {
          this.loading = true
          this.$store.dispatch('image/put', { id: this.id, item: this.getData() })
            .catch(() => {})
            .finally(() => {
              this.loading = false
            })
        }
      })
    },
    initData() {
      this.loading = true
      Promise.all([
        this.$store.dispatch('imageCategory/getList'),
      ])
        .then(() => {
          this.initDetail()
        })
        .catch(() => {})
        .finally(() => {
          this.loaded.push('icy')
          this.loading = false
        })
    },
    initDetail() {
      this.$store.dispatch('image/getOne', this.id)
        .then(() => {
          this.form.setFieldsValue({
            icy_id: this.detail.icy_id,
            iae_name: this.detail.iae_name,
          })
          this.focal = {
            x: this.detail.iae_focal_x ?? 50,
            y: this.detail.iae_focal_y ?? 50,
          }
        })
        .catch(() => {})
    },
    error(fieldName) {
      const { getFieldError, isFieldTouched } = this.form
      return isFieldTouched(fieldName) && getFieldError(fieldName)
    },
    refreshComponent(id) {
      this.id = id
      this.loaded = []
      this.focal = { x: 50, y: 50 }
    },
  },
  created() {
    this.initData()
  },
  watch: {
    '$route.params.id'(newId, oldId) {
      this.refreshComponent(newId)
      this.initDetail()
    },
  },
}
</script>

<style lang="scss" module>
  @import "./style.module.scss";
</style>
